import { render, staticRenderFns } from "./ModificarOrdenPago.vue?vue&type=template&id=53db3774&scoped=true&"
import script from "./ModificarOrdenPago.vue?vue&type=script&lang=js&"
export * from "./ModificarOrdenPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53db3774",
  null
  
)

export default component.exports